// NotFound Component
import React from 'react';

const NotFound = () => {

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <div style={{ textAlign: 'center', marginTop: '50px', padding: '10px', maxWidth: '400px', margin: 'auto' }}>
        <h1 style={{ fontSize: '2em', marginBottom: '10px' }}>404</h1>
        <h2 style={{ color: "black", fontSize: '1.5em' }}>Page Not Found</h2>
        <p style={{ fontSize: '1em', padding: '20px', }}>Oops! It seems like the page you are looking for doesn't exist.</p>
      </div>
    </div>
  );
};

export default NotFound;
